import React, { useEffect, useState } from 'react';

interface Coordinates {
  latitude: number;
  longitude: number;
}

interface MapProps {
  address: string;
}

const Map: React.FC<MapProps> = ({ address }) => {
  const [coordinates, setCoordinates] = useState<Coordinates | null>(null);

  useEffect(() => {
    const getCoordinates = async () => {
      try {
        const response = await fetch(
          `https://dev.virtualearth.net/REST/v1/Locations?q=${encodeURIComponent(
            address
          )}&key=AqWLsrIYZHeAx_iFT7sxf37puoz0z4qYNw_zPN1v5VKh7evJgxDtzY2tF9s55_44`
        );
        const data = await response.json();
        if (
          data.resourceSets &&
          data.resourceSets.length > 0 &&
          data.resourceSets[0].resources.length > 0
        ) {
          const location = data.resourceSets[0].resources[0].point.coordinates;
          setCoordinates({ latitude: location[0], longitude: location[1] });
        } else {
          console.error('Address not found');
        }
      } catch (error) {
        console.error('Error fetching coordinates:', error);
      }
    };

    getCoordinates();
  }, [address]);

  return coordinates ? (
    <iframe
      width="100%"
      height="300"
      frameBorder="0"
      style={{ border: 0 }}
      src={`https://www.bing.com/maps/embed?h=300&w=500&cp=${coordinates.latitude}~${coordinates.longitude}&lvl=16&typ=d&sty=r&key=AqWLsrIYZHeAx_iFT7sxf37puoz0z4qYNw_zPN1v5VKh7evJgxDtzY2tF9s55_44`}
      allowFullScreen
    ></iframe>
  ) : (
    <p>Carregando mapa...</p>
  );
};

export default Map;
